"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _styles = require("@material-ui/core/styles");

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _useRedirect = _interopRequireDefault(require("@sprinx/react-routes/useRedirect"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      position: 'relative',
      width: '100%',
      maxWidth: 350
    }, theme.breakpoints.down('sm'), {
      position: 'initial'
    }),
    search: {
      position: 'relative',
      borderRadius: 6,
      overflow: 'hidden',
      backgroundColor: theme.palette.secondary.background,
      marginLeft: 0,
      width: '100%',
      border: '1px solid rgba(0,0,0,.2)',
      height: 45
    },
    searchIcon: {
      width: theme.spacing(7),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      right: 0
    },
    inputRoot: {
      color: 'inherit',
      height: 45
    },
    inputInput: {
      padding: theme.spacing(1, 7, 1, 1),
      transition: theme.transitions.create('width'),
      width: '100%'
    },
    results: {
      position: 'absolute',
      left: 0,
      top: '100%',
      right: 0,
      background: theme.palette.background.default,
      boxShadow: theme.shadows[3],
      zIndex: theme.zIndex.appBar,
      overflowY: 'scroll',
      maxHeight: 400
    }
  };
}, {
  name: 'SxGlobalSearchField'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_Search.default, null);

function GlobalSearchField(_ref) {
  var className = _ref.className,
      getSearchResult = _ref.getSearchResult,
      onChange = _ref.onChange,
      path = _ref.path,
      searchDelay = _ref.searchDelay,
      searchLimit = _ref.searchLimit,
      SearchResultSelector = _ref.SearchResultSelector,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className", "getSearchResult", "onChange", "path", "searchDelay", "searchLimit", "SearchResultSelector"]);
  var t = (0, _useTranslate.default)();
  var classes = useStyles({});
  var setRedirect = (0, _useRedirect.default)(); // const routeBuilder = useRouteBuilder(path, ':query');

  var _React$useState = _react.default.useState(''),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      searchQuery = _React$useState2[0],
      setSearchQuery = _React$useState2[1];

  var _React$useState3 = _react.default.useState(null),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      resultV = _React$useState4[0],
      setResultV = _React$useState4[1];

  var _React$useState5 = _react.default.useState(null),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      open = _React$useState6[0],
      setOpen = _React$useState6[1];

  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));

  var handleSearch = _react.default.useCallback(function (v) {
    getSearchResult(v).then(function (res) {
      setResultV(res);
    }).catch(function (err) {
      return console.log(err);
    }); // eslint-disable-line no-console
  }, [getSearchResult]);

  var handleChange = function handleChange(event) {
    event.preventDefault();
    var value = event.target.value;
    setSearchQuery(value);

    if (value.length >= searchLimit) {
      return setOpen(true);
    }

    return setOpen(false);
  };

  var handleRedirectToSearchResult = function handleRedirectToSearchResult() {
    return setRedirect({
      pathname: '/search',
      search: "?q=".concat(searchQuery)
    }, {
      searchQuery: searchQuery
    });
  };

  var handleClose = function handleClose() {
    if (onChange) {
      onChange();
    }

    setOpen(false);
    setSearchQuery('');
  };

  _react.default.useEffect(function () {
    var delayTyping;

    if (searchQuery && searchQuery.length >= searchLimit) {
      delayTyping = setTimeout(function () {
        return handleSearch(searchQuery);
      }, searchDelay);
    } else setResultV(null);

    return function () {
      return clearTimeout(delayTyping);
    };
  }, [handleSearch, searchDelay, searchLimit, searchQuery]);

  return /*#__PURE__*/_react.default.createElement(_ClickAwayListener.default, {
    onClickAway: mobile ? handleClose : function () {}
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.search
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.searchIcon
  }, _ref2), /*#__PURE__*/_react.default.createElement(_InputBase.default, {
    placeholder: t('app/actions/search'),
    classes: {
      root: classes.inputRoot,
      input: classes.inputInput
    },
    inputProps: {
      'aria-label': t('app/actions/search')
    },
    value: searchQuery,
    onChange: handleChange,
    onKeyPress: function onKeyPress(event) {
      if (event.key === 'Enter' && searchQuery.length >= searchLimit) {
        handleRedirectToSearchResult();
        handleClose();
      }
    }
  })), open && resultV && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.results
  }, resultV.map(function (res, index) {
    return /*#__PURE__*/_react.default.createElement(SearchResultSelector, (0, _extends2.default)({
      onClose: handleClose,
      key: index.toString(),
      result: res
    }, rest));
  }))));
}

process.env.NODE_ENV !== "production" ? GlobalSearchField.propTypes = {
  className: _propTypes.default.string,
  getSearchResult: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func,
  path: _propTypes.default.string,
  searchDelay: _propTypes.default.number,
  searchLimit: _propTypes.default.number,
  SearchResultSelector: _propTypes.default.elementType.isRequired
} : void 0;
GlobalSearchField.defaultProps = {
  className: undefined,
  onChange: undefined,
  path: '/search',
  searchDelay: 250,
  searchLimit: 3
};
var _default = GlobalSearchField;
exports.default = _default;